const CX = "PdfMenu";

export { CX };
